import axiosClient from '../apiClient'

/**
 * get the data points through a post request
 * @param id the identifier of the point array
*/
export function gamePrediction(
  data: any
): Promise<any> {
  const promise = axiosClient.post<any>("game-prediction", data);
  return promise
    .then((res) => {
      if (res.status !== 204) {
        return res.data;
      }
      return undefined;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
}

export function tactics(
  data: any
): Promise<any> {
  const promise = axiosClient.post<any>("tactics", data);
  return promise
    .then((res) => {
      if (res.status !== 204) {
        return res.data;
      }
      return undefined;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
}

export function pairwiseFeatures(
  data: any
): Promise<any> {
  const promise = axiosClient.post<any>("pairwise-features", data);
  return promise
    .then((res) => {
      if (res.status !== 204) {
        return res.data;
      }
      return undefined;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
}

export function tactical_analysis(
  data: any
): Promise<any> {
  const promise = axiosClient.post<any>("tactical-statistic", data);
  return promise
    .then((res) => {
      if (res.status !== 204) {
        return res.data;
      }
      return undefined;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
}

export function team_configs(
  data: any
): Promise<any> {
  const promise = axiosClient.post<any>("team-configs", data);
  return promise
    .then((res) => {
      if (res.status !== 204) {
        return res.data;
      }
      return undefined;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
}

export function game_counterfactuals(
  data: any
): Promise<any> {
  const promise = axiosClient.post<any>("game-prediction-counterfactual", data);
  return promise
    .then((res) => {
      if (res.status !== 204) {
        return res.data;
      }
      return undefined;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
}